import { META_PIXEL_ID } from '../data/analytics'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

let initialized = false

/**
 * Official Meta Pixel base code for Pequeñas Puntadas.
 * Initializes only META_PIXEL_ID and sends a single PageView per page load.
 * No other events are sent from the landing — purchase events
 * (InitiateCheckout, Purchase) are configured in Impultienda.
 */
export function initMetaPixel(): void {
  if (!META_PIXEL_ID || initialized) return
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  initialized = true

  /* eslint-disable */
  ;(function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.src = v
    s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      ;(b.head || b.body || b.documentElement).appendChild(t)
    }
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
  /* eslint-enable */

  window.fbq?.('init', META_PIXEL_ID)
  window.fbq?.('track', 'PageView')

  // The <noscript> fallback only works as static markup in index.html (a
  // script-built <noscript> would fire a duplicate PageView):
  // <noscript><img height="1" width="1" style="display:none"
  //   src="https://www.facebook.com/tr?id=2152270442033357&ev=PageView&noscript=1" /></noscript>
  // Defensive cleanup of any legacy script-injected node from the old fork.
  document.getElementById('meta-pixel-noscript')?.remove()
}
